module.exports = __webpack_public_path__ + "img/close.7ab2e602.svg";